import { RECEIVE_PRODUCTS } from '../productList/productListConstants';

const appliedFacets = (
  state = {
    facets: [],
    facetItems: [], // contains uids: `${facetId}:${facetItem.id}`
    itemsPerFacet: {}, // contains facetId: [facetItem.id]
    needValidation: false,
  },
  action
) => {
  switch (action.type) {
    case 'FACET_ITEM_APPLIED': {
      const { id: itemId, facet } = action.item;
      const currentItems = state.itemsPerFacet[facet] || [];
      const updatedItemsPerFacet = {
        ...state.itemsPerFacet,
        [facet]: [...currentItems, itemId],
      };
      const updatedFacets = state.facets.includes(facet) ? state.facets : [...state.facets, facet];
      return {
        facets: updatedFacets,
        facetItems: updatedFacets.reduce(
          (acc, facetId) => [...acc, ...updatedItemsPerFacet[facetId].map(facetItemId => `${facetId}:${facetItemId}`)],
          []
        ),
        itemsPerFacet: updatedItemsPerFacet,
      };
    }
    case 'FACET_ITEM_REMOVED': {
      const { id: itemId, uid: itemUid, facet } = action.item;
      const remainingFacetItems = state.itemsPerFacet[facet].filter(item => item !== itemId);
      const remainingItemsPerFacet = Object.entries(state.itemsPerFacet).reduce((acc, [facetId, items]) => {
        if (facetId !== facet) {
          return { ...acc, [facetId]: items };
        }
        if (remainingFacetItems.length) {
          return { ...acc, [facetId]: remainingFacetItems };
        }
        return acc;
      }, {});
      return {
        facets: Object.keys(remainingItemsPerFacet),
        facetItems: state.facetItems.filter(uid => uid !== itemUid),
        itemsPerFacet: remainingItemsPerFacet,
      };
    }
    case RECEIVE_PRODUCTS: {
      if (!action.mustValidateURLParams || Object.keys(state.itemsPerFacet).length === 0) {
        return state;
      }
      const facetsMetadata = action.searchMetadata.facets;
      const validAppliedItemsPerFacet = facetsMetadata.reduce((acc, { id, values: items }) => {
        const appliedItems = items.filter(item => item.selected).map(item => item.id);
        if (appliedItems.length === 0) {
          return acc;
        }
        return { ...acc, [id]: appliedItems };
      }, {});
      return {
        facets: Object.keys(validAppliedItemsPerFacet),
        facetItems: Object.entries(validAppliedItemsPerFacet).reduce(
          (acc, [facetId, itemIds]) => [...acc, ...itemIds.map(itemId => `${facetId}:${itemId}`)],
          []
        ),
        itemsPerFacet: validAppliedItemsPerFacet,
        needValidation: false,
      };
    }
    case 'URL_HASH_APPLIED':
    case 'URL_HASH_CHANGED': {
      const { searchFacets } = action;
      return {
        facets: Object.keys(searchFacets),
        facetItems: Object.entries(searchFacets).reduce(
          (acc, [facetId, itemIds]) => [...acc, ...itemIds.map(itemId => `${facetId}:${itemId}`)],
          []
        ),
        itemsPerFacet: searchFacets,
        needValidation: true,
      };
    }
    case 'ALL_FACETS_REMOVED': {
      return {
        facets: [],
        facetItems: [],
        itemsPerFacet: {},
        needValidation: false,
      };
    }
    // TODO
    case 'AVAILABLE_FACETS_UPDATED':
      return state;
    default:
      return state;
  }
};

export default appliedFacets;

export const getFacetItemIds = (state, facetId) => state.itemsPerFacet[facetId] || [];
export const getAllFacetItemUids = state => state.facetItems;

export const getFacetIds = state => state.facets;
export const getItemIdsPerFacet = state => state.itemsPerFacet;
export const getForAPIQueryParam = state =>
  Object.entries(state.itemsPerFacet).reduce(
    (result, [facetId, facetItems]) => ({
      ...result,
      [facetId]: facetItems.reduce((acc, item) => ({ ...acc, [item]: true }), {}),
    }),
    {}
  );

export const getForURLHash = state =>
  Object.entries(state.itemsPerFacet)
    .map(([facet, facetItems]) => `${facet}=${facetItems.join(';')}`)
    .join('&');
